import axios from "axios";

const getDataWithToken = async (
  url,
  admin_panel_user,
  logout,
  responseType
) => {
  try {
    // function getCookie(name) {
    //   const cookies = document.cookie.split(";");
    //   for (let i = 0; i < cookies.length; i++) {
    //     const cookie = cookies[i].trim();
    //     if (cookie.startsWith(name + "=")) {
    //       const cookieValue = decodeURIComponent(
    //         cookie.substring(name.length + 1)
    //       );
    //       return JSON.parse(cookieValue);
    //     }
    //   }
    //   return {}; // Cookie not found
    // }
    // const localData = getCookie("admin_panel_user");

    const localData = JSON.parse(localStorage.getItem("admin_panel_user"));

    // console.log("localData.token", localData.token);
    let response = await axios({
      method: "get",
      url: url,
      headers: {
        Authorization: `Bearer ${admin_panel_user.token}`,
      },
      responseType: responseType ? responseType : "",
    });
    console.log("response 111111111111", response);
    if (response.data.status === false && response.data.code === 401) {
      logout();
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error.response;
    // if (error.response.status === 401) {
    //   logout();
    // } else {
    //   return error.response;
    // }
  }
};

export { getDataWithToken };
